export default __webpack_public_path__ + "static/media/cases.852726d9.svg";